import React from "react";
import {Feature} from "../../../gd/access-control/feature-access/const"
import {featureAccess} from "../../../gd/access-control/feature-access/feature-access"


export function Actions_AddPopoverMenuOption(projectId?:ID):Option {


    if (!gd.company.acl.canCreateActions) {
        return {
            // @ts-ignore
            label   : <span className="ui5-txt-disabled">New action</span>,
            icon    : 'i5-plus fs-11 ui5-color-disabled-i',
            // onClick : () => {
            //
            // },
        }
    }

    return {
        // @ts-ignore
        label   : <span className="ui5-txt-no-accent-default">New action</span>,
        // icon    : 'i5-plus',
        icon    : 'i5-plus fs-11 ui5-color-action-i',
        onClick : () => {
            // props.hidePopover()
            gd.layout.popovers.closeAll()

            if (!featureAccess(Feature.ACTIONS)) {
                return gd.modals.other.upgrade(Feature.ACTIONS)
            }

            if (projectId) {
                gd.tempParamsStorage.add('automationProjectId', projectId)
            }

            gd.goTo('action/new')
        },
    }

}